<template>
	<div class="chart">
		<div style="flex: 1; height: 100%">
			<BaseChart :option="baseOption" />
		</div>
		<div class="rl">
			<div class="item">
				<div class="title">线索成交率</div>
				<div class="val">12.4%</div>
			</div>
			<div class="item-error">
				<div class="title-error">流失率严重阶段</div>
				<div class="val-error">商务谈判--签约</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FunnelAnalysis',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			baseOption() {
				const data = [
					{ value: 60, name: '商务谈判' },
					{ value: 40, name: '已签约' },
					{ value: 80, name: 'R需求确认' },
					{ value: 100, name: '初步接洽' },
				];

				// 👇 按漏斗顺序排序（大的在上）
				const sortedData = data.sort((a, b) => b.value - a.value);

				const values = sortedData.map(item => item.value);
				const names = sortedData.map(item => item.name);

				const max = Math.max(...values);

				// 👇 关键：计算居中偏移
				const offsetData = values.map(v => (max - v) / 2);

				return {
					grid: {
						bottom: '10%',
						right: '10%',
						top: '10%',
						left: '5%',
						containLabel: true,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: { type: 'none' },
						formatter: params => {
							const item = params[1]; // 第二个 series 才是真数据
							return `${item.name} : ${item.value}%`;
						},
					},
					xAxis: {
						type: 'value',
						show: false,
					},
					yAxis: {
						show: false,
						type: 'category',
						data: names,
						inverse: true, // 👈 从上到下
						axisTick: { show: false },
						axisLine: { show: false },
					},
					series: [
						{
							type: 'bar',
							stack: 'total',
							data: offsetData,
							itemStyle: {
								color: 'transparent',
							},
							tooltip: { show: false },
						},
						{
							name: 'Funnel',
							type: 'bar',
							stack: 'total',
							data: values,
							barWidth: '90%',
							itemStyle: {
								borderRadius: 4,
								borderColor: '#fff',
								borderWidth: 1,
								color: params => {
									const colorList = ['#4080FF', '#6296FF', '#8A7CFE', '#B3D5FF'];
									return colorList[params.dataIndex];
								},
							},
							// label: {
							// 	show: true,
							// 	position: 'right',
							// 	formatter: ({ name, value }) => {
							// 		return `{name|${name}}{value|${value}}`;
							// 	},
							// 	rich: {
							// 		name: {
							// 			fontSize: 18,
							// 			fontWeight: 'bold',
							// 			color: '#fff',
							// 		},
							// 		value: {
							// 			fontSize: 18,
							// 			fontWeight: 'bold',
							// 			color: '#fff',
							// 		},
							// 	},
							// },
							label: {
								show: true,
								offset: [100, 0],
								position: 'left', // 👈 左侧固定 name
								formatter: '{b}',
								color: '#fff',
								fontSize: 16,
							},
							emphasis: {
								itemStyle: {
									opacity: 0.8,
								},
							},
						},
						{
							type: 'bar',
							stack: 'label',
							data: offsetData,
							itemStyle: {
								color: 'transparent',
							},
							tooltip: { show: false },
						},
						{
							type: 'bar',
							data: values,
							stack: 'label', // 👈 单独一层
							barGap: '-100%',
							itemStyle: { color: 'transparent' },
							barWidth: '90%',
							label: {
								show: true,
								offset: [-60, 0],
								position: 'right',
								formatter: '{c}',
								color: '#FFFFFF',
								fontSize: 22,
							},
						},
					],
				};
			},
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.chart {
		width: 100%;
		height: 100%;
		display: flex;
		gap: 10px;
	}
	.rl {
		width: 30%;
		display: flex;
		flex-direction: column;
		gap: 30px;
		justify-content: center;
		align-items: center;
	}
	.item,
	.item-error {
		width: 50%;
		height: 99px;
		background: #eff6ff;
		border-radius: 8px;
		border: 1px solid #cce2ff;
		padding: 13px;
		box-sizing: border-box;
	}
	.title,
	.title-error {
		font-weight: 500;
		font-size: 14px;
		color: #1d2129;
	}
	.val,
	.val-error {
		font-weight: 600;
		font-size: 30px;
		color: #1d2129;
		margin-top: 4px;
	}
	.item-error {
		background: #fef2f2;
		box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
		border: 1px solid rgba(239, 68, 68, 0.2);
	}
	.title-error {
		color: #ef4444;
	}
	.val-error {
		font-size: 24px;
		color: #ef4444;
	}
</style>
